import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { setSessionstorage } from "../helpers/sessionStorage";
import { AlertContext } from "../contexts/AlertContext";
import { LoaderContext } from "../contexts/LoaderContext";
import 'animate.css';

export const useLogin = () => {

    const { validarLogin } = useContext(AuthContext);
    const { alertRef } = useContext(AlertContext);
    const { setOpenLoader } = useContext(LoaderContext);

    const iniciarSesion = async (dataForm) => {
        setOpenLoader(true);

        const { username, ...rest } = dataForm;

        const payload = {
            ...rest,
            username: username.toLowerCase(),
            view: 'dashboard'
        } 
        const response = await fetch(`/api/auth/login`, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const { ok, message, data } = await response.json();

        if(!ok) {
            setOpenLoader(false);
            alertRef.current.handleOpen('error', message);
            return;   
        }

        setSessionstorage(data?.token);
        validarLogin();
    }

    return {
        iniciarSesion
    }
}